module.exports = __webpack_public_path__ + "img/100.2d05046f.jpg";